import { StorageEnums } from 'app/storage-offer/storage-enum-values';
import * as angular from 'angular';

class LngProductComponentFormComponentCtrl implements ng.IController {
    public enums = StorageEnums;

    $onInit() {}
}

angular.module('app').component('pkpLngProductComponentForm', {
    controller: LngProductComponentFormComponentCtrl,
    template: require('app/lng-offer/lng-product-component-form.component.html'),
    bindings: {
        productComponent: '<',
        componentDisabled: '<',
        outerForm: '<',
        productIndex: '<',
        productComponentIndex: '<',
        runtime: '<',
        onRemove: '&',
        offerRuntime: '<'
    }
});
